import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import Button from '../atoms/Button';
import styles from '../../styles/components/molecules/AddItem.module.scss';

interface AddItemProps {
  className?: string;
  onClick: () => void;
  href?: string;
  label: string;
  restricted?: boolean;
}

export default function AddItem(props: AddItemProps) {
  const { restricted, label, href, onClick, className } = props;
  const { addItem } = styles;
  const { t } = useTranslation(['common']);
  const classes = clsx(addItem, className);
  return (
    <div className={classes}>
      <Button
        large
        white
        full
        iconLeft
        label={label}
        icon={'add'}
        href={restricted ? href : null}
        onClick={onClick}
      />
      {restricted && (
        <small>
          <span>{t(`common:premium-function`)}</span>
          <Button small round gold icon={'rocket'} />
        </small>
      )}
    </div>
  );
}
